import React, { useContext } from 'react'
import MapContext from '../context/MapContex'
import CancelIcon from '@material-ui/icons/Cancel';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import StoreIcon from '@material-ui/icons/Store';
import ApartmentIcon from '@material-ui/icons/Apartment';
import HouseIcon from '@material-ui/icons/House';
import BathtubIcon from '@material-ui/icons/Bathtub';
import LocalHotelIcon from '@material-ui/icons/LocalHotel';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import DirectionsIcon from '@material-ui/icons/Directions';

const ModalContent = ({ data }) => {
	const { nameProperty, valorVenta, hdnBusinessType, cityname, propertyType, numBanos, numHabitaciones, Parqueadero, Estrato, zona, url_inmuebles } = data[0];
	const { close_modal } = useContext(MapContext)

	if (!data) {
		<h1>Cargado...</h1>
	}
	return (
		<div className="modal__content">
			<div className="modal__header">
				<div className="modal__header__title"><h4>{nameProperty}</h4></div>
				<div className="modal__header__icon"><CancelIcon onClick={() => close_modal()} className="close" /></div>
			</div>
			<div className="modal__content_body">
				<ul>
					<li>
						<div className="modal__content__icons">
							<LocalAtmIcon /> <p>Valor Propiedad</p>
						</div>
						<div className="modal__content__property">{valorVenta && valorVenta}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<AnnouncementIcon /> <p>Descripcion</p>
						</div>
						<div className="modal__content__property">{hdnBusinessType && hdnBusinessType}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<ApartmentIcon /> <p>Ciudad</p>
						</div>
						<div className="modal__content__property">{cityname && cityname}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<HouseIcon /> <p>Tipo</p>
						</div>
						<div className="modal__content__property">{propertyType && propertyType}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<BathtubIcon /> <p>Baños</p>
						</div>
						<div className="modal__content__property">{numBanos && numBanos}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<LocalHotelIcon /> <p>Numero de habitaciones</p>
						</div>
						<div className="modal__content__property">{numHabitaciones && numHabitaciones}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<EmojiTransportationIcon /> <p>Parqueadero</p>
						</div>
						<div className="modal__content__property">{Parqueadero && Parqueadero}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<AssignmentLateIcon /> <p>Estrato</p>
						</div>
						<div className="modal__content__property">{Estrato && Estrato}</div>
					</li>
					<li>
						<div className="modal__content__icons">
							<DirectionsIcon /> <p>Zona</p>
						</div>
						<div className="modal__content__property">{zona && zona}</div>
					</li>
				</ul>
			</div>
			<div className="modal__footer">
				<div className="modal__footer__button">
					<a href={url_inmuebles} target="_blank" className="href">IR AL INMUEBLE</a>
				</div>

			</div>
		</div>
	)
}

export default ModalContent
